import React, { useState } from 'react';
import clockOrange from '../../assets/images/clock_orange.svg';
import canceled from '../../assets/images/canceled.svg';
import {
  VisitDetailsModalOverlay,
  VisitDetailsModalContainer,
  InAnalysisModalContainer,
  VisitDetailsModalHeader,
  VisitDetailsModalTitle,
  VisitDetailsCloseButton,
  VisitDetailsStatusBadge,
  InAnalysisStatusBadgeOrange,
  NotRealizedStatusBadge,
  ConfirmedInfoBox,
  ConfirmedIconContainer,
  ConfirmedMessage,
  NotRealizedInfoBox,
  NotRealizedIconContainer,
  NotRealizedMessage,
  VisitDetailsSection,
  VisitDetailsSectionTitle,
  VisitDetailsSummaryItem,
  VisitDetailsSummaryIcon,
  VisitDetailsSummaryContent,
  VisitDetailsSummaryLabel,
  VisitDetailsSummaryValue,
  VisitDetailsRatingSection,
  VisitDetailsRatingNumber,
  VisitDetailsRatingStars,
  VisitDetailsRatingText,
  VisitDetailsTag,
  EvaluationButtonsContainer,
  EvaluationSubmitButton,
  VisitSummaryText,
  PlanContainer,
  PlanTitle,
  PlanText,
  PlanDivider,
  VisitTagsContainerCustom,
  VisitSectionSpaced,
  RatingStarImageClickable,
  ToggleButton,
  AttentionTitle,
  LegalText,
} from './styles';

import starSvg from '../../assets/images/star.svg';

const VisitDetailsModal = ({ isOpen, onClose, visit, onRequestRating }) => {
  const [expandedSections, setExpandedSections] = useState({
    summary: false,
    consultorPlan: false,
    resellerPlan: false,
  });

  const charLimit = 300;

  const hasExistingRating =
    visit &&
    visit.rating !== null &&
    visit.rating !== undefined &&
    Number.isInteger(visit.rating);
  const currentRating = hasExistingRating ? visit.rating : 0;
  const hasCommitment = !!(
    visit &&
    visit.raw &&
    (visit.raw.commitmentId || visit.raw.Id || visit.raw.commitment_id_sf)
  );

  const handleAvaliarClick = () => {
    if (typeof onRequestRating === 'function') {
      onRequestRating(visit);
    }
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const toggleSection = sectionName => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName],
    }));
  };

  const formatDateWithPeriod = dateString => {
    if (!dateString) return '';
    const parts = dateString.split(' às ');
    if (parts.length !== 2) return dateString;

    const [date] = parts;
    return date;
  };

  const shouldShowToggle = text => text && text.length > charLimit;

  const renderTextWithToggle = (text, sectionName) => {
    if (!text) return text;
    const isExpanded = expandedSections[sectionName];
    const shouldShow = shouldShowToggle(text);

    return (
      <div>
        <div>
          {isExpanded
            ? text
            : shouldShow
            ? `${text.substring(0, charLimit)}...`
            : text}
        </div>
        {shouldShow && (
          <ToggleButton onClick={() => toggleSection(sectionName)}>
            {isExpanded ? 'Ver menos' : 'Ver mais'}
          </ToggleButton>
        )}
      </div>
    );
  };

  if (!isOpen || !visit.raw.StatusDaVisita) return null;

  const renderModalContent = () => {
    switch (visit.raw.StatusDaVisita) {
      case 'Agendado':
        return (
          <InAnalysisModalContainer onClick={e => e.stopPropagation()}>
            <VisitDetailsModalHeader>
              <VisitDetailsModalTitle>
                Detalhes da visita
              </VisitDetailsModalTitle>
              <VisitDetailsCloseButton onClick={onClose}>
                ×
              </VisitDetailsCloseButton>
            </VisitDetailsModalHeader>

            <InAnalysisStatusBadgeOrange>Agendado</InAnalysisStatusBadgeOrange>

            <ConfirmedInfoBox>
              <ConfirmedIconContainer>
                <img src={clockOrange} alt="Relógio" width="40" height="40" />
              </ConfirmedIconContainer>
              <ConfirmedMessage>
                Visita realizada. Prepare-se para receber
                <br />o consultor em{' '}
                <strong>{formatDateWithPeriod(visit.date)}</strong>.
              </ConfirmedMessage>
            </ConfirmedInfoBox>

            {renderSummarySection()}
          </InAnalysisModalContainer>
        );

      case 'Cancelado':
        return (
          <InAnalysisModalContainer onClick={e => e.stopPropagation()}>
            <VisitDetailsModalHeader>
              <VisitDetailsModalTitle>
                Detalhes da visita
              </VisitDetailsModalTitle>
              <VisitDetailsCloseButton onClick={onClose}>
                ×
              </VisitDetailsCloseButton>
            </VisitDetailsModalHeader>

            <NotRealizedStatusBadge>Cancelado</NotRealizedStatusBadge>

            <NotRealizedInfoBox>
              <NotRealizedIconContainer>
                <img src={canceled} alt="Cancelado" width="40" height="40" />
              </NotRealizedIconContainer>
              <NotRealizedMessage>
                A visita foi cancelada. Em breve será agendada uma nova visita.
              </NotRealizedMessage>
            </NotRealizedInfoBox>

            {renderSummarySection()}
          </InAnalysisModalContainer>
        );

      case 'Realizado':
      default: {
        const hasCommitment = !!(visit && visit.raw && visit.raw.commitmentId);
        const hasAnyRatingOrCommitment =
          (visit && visit.rating != null) ||
          (visit &&
            visit.raw &&
            (visit.raw.commitmentId != null ||
              visit.raw.confirm != null ||
              visit.raw.finished != null));
        return (
          <VisitDetailsModalContainer onClick={e => e.stopPropagation()}>
            <VisitDetailsModalHeader>
              <VisitDetailsModalTitle>
                Detalhes da visita
              </VisitDetailsModalTitle>
              <VisitDetailsCloseButton onClick={onClose}>
                ×
              </VisitDetailsCloseButton>
            </VisitDetailsModalHeader>

            <VisitDetailsStatusBadge status={visit.raw.StatusDaVisita}>
              {visit.raw.StatusDaVisita}
            </VisitDetailsStatusBadge>

            {hasAnyRatingOrCommitment && (
              <VisitDetailsRatingSection>
                <VisitDetailsRatingNumber>
                  {currentRating > 0 ? currentRating : ''}
                </VisitDetailsRatingNumber>
                <VisitDetailsRatingStars>
                  {[1, 2, 3, 4, 5].map(star => (
                    <RatingStarImageClickable
                      key={star}
                      src={starSvg}
                      alt="Estrela"
                      width="20"
                      height="20"
                      isActive={star <= currentRating}
                      hasExistingRating={hasExistingRating}
                      style={{ cursor: 'default', pointerEvents: 'none' }}
                    />
                  ))}
                </VisitDetailsRatingStars>
                <VisitDetailsRatingText>
                  {hasExistingRating
                    ? 'Avaliação da visita'
                    : hasCommitment
                    ? 'Clique no botão abaixo para avaliar'
                    : ''}
                </VisitDetailsRatingText>

                {visit.tags && (
                  <VisitTagsContainerCustom
                    style={{ justifyContent: 'center' }}
                  >
                    {visit.tags.map((tag, index) => (
                      <VisitDetailsTag key={index}>{tag}</VisitDetailsTag>
                    ))}
                  </VisitTagsContainerCustom>
                )}

                {!hasExistingRating && hasCommitment && (
                  <EvaluationButtonsContainer>
                    <EvaluationSubmitButton onClick={handleAvaliarClick}>
                      Avaliar
                    </EvaluationSubmitButton>
                  </EvaluationButtonsContainer>
                )}
              </VisitDetailsRatingSection>
            )}

            {renderSummarySection()}

            {visit.raw.StatusDaVisita === 'Realizado' && (
              <>
                <VisitSectionSpaced>
                  <VisitDetailsSectionTitle>
                    Resumo da visita
                  </VisitDetailsSectionTitle>
                  <VisitSummaryText>
                    {renderTextWithToggle(
                      visit.description ||
                        (visit.raw &&
                          (visit.raw.Description || visit.raw.description)) ||
                        'Resumo não disponível.',
                      'summary',
                    )}
                  </VisitSummaryText>
                </VisitSectionSpaced>

                <VisitSectionSpaced>
                  <VisitDetailsSectionTitle>
                    Planos de ação
                  </VisitDetailsSectionTitle>

                  <PlanContainer>
                    <PlanTitle>Consultor</PlanTitle>
                    <PlanText>
                      {renderTextWithToggle(
                        (visit.raw && visit.raw.PlanosDeAcaoConsultor) ||
                          'Plano de ação não informado pelo consultor.',
                        'consultorPlan',
                      )}
                    </PlanText>

                    <PlanDivider />

                    <PlanTitle>Revendedor</PlanTitle>
                    <PlanText>
                      {renderTextWithToggle(
                        (visit.raw && visit.raw.PlanosDeAcaoRevendedor) ||
                          'Plano de ação não informado pelo revendedor.',
                        'resellerPlan',
                      )}
                    </PlanText>
                  </PlanContainer>
                </VisitSectionSpaced>

                <AttentionTitle>ATENÇÃO 🚨</AttentionTitle>
                <LegalText>
                  <b>RESSALVA LEGAL: </b>
                  Os eventuais compromissos assumidos pela Ultragaz nesta
                  mensagem consideram exclusivamente o contexto atual da
                  negociação e da relação contratual entre a Ultragaz e V.
                  Senhoria, estando condicionados ao cumprimento integral de
                  todas as obrigações assumidas por V. Senhoria, seja de
                  natureza contratual ou decorrente de outro meio.
                  <br />
                  <br />
                  <b>AVISO DE CONFIDENCIALIDADE: </b>
                  Esta mensagem, incluindo seus anexos, contém informações
                  confidenciais destinadas exclusivamente ao responsável pelo
                  estabelecimento comercial destinatário e somente poderá ser
                  utilizada no âmbito da relação comercial existente entre a
                  Ultragaz e V. Senhoria. É expressamente proibido o uso,
                  acesso, reprodução ou divulgação não autorizada do conteúdo
                  desta mensagem, sob pena de infração contratual. Caso você não
                  seja o destinatário, fica desde já notificado de que não
                  poderá utilizar, copiar ou divulgar as informações aqui
                  contidas, devendo delatar a mensagem imediatamente, sob pena
                  de responder no âmbito cível e criminal.
                </LegalText>
              </>
            )}
          </VisitDetailsModalContainer>
        );
      }
    }
  };

  const renderSummarySection = () => (
    <VisitDetailsSection>
      <VisitDetailsSectionTitle>Resumo</VisitDetailsSectionTitle>

      <VisitDetailsSummaryItem>
        <VisitDetailsSummaryIcon>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M6 2V4H14V2H16V4H18C19.1 4 20 4.9 20 6V18C20 19.1 19.1 20 18 20H2C0.9 20 0 19.1 0 18V6C0 4.9 0.9 4 2 4H4V2H6ZM18 8H2V18H18V8Z"
              fill="#636363"
            />
          </svg>
        </VisitDetailsSummaryIcon>
        <VisitDetailsSummaryContent>
          <VisitDetailsSummaryLabel>Data da visita</VisitDetailsSummaryLabel>
          <VisitDetailsSummaryValue>
            {formatDateWithPeriod(visit.date)}
          </VisitDetailsSummaryValue>
        </VisitDetailsSummaryContent>
      </VisitDetailsSummaryItem>

      <VisitDetailsSummaryItem>
        <VisitDetailsSummaryIcon>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M12 2C13.1 2 14 2.9 14 4V5H16C17.1 5 18 5.9 18 7V17C18 18.1 17.1 19 16 19H4C2.9 19 2 18.1 2 17V7C2 5.9 2.9 5 4 5H6V4C6 2.9 6.9 2 8 2H12ZM12 4H8V7H12V4ZM16 7H4V17H16V7Z"
              fill="#636363"
            />
          </svg>
        </VisitDetailsSummaryIcon>
        <VisitDetailsSummaryContent>
          <VisitDetailsSummaryLabel>Assunto</VisitDetailsSummaryLabel>
          <VisitDetailsSummaryValue>
            {visit.raw.StatusDaVisita === 'Agendada' ||
            visit.raw.StatusDaVisita === 'Cancelado'
              ? visit.subject || 'Treinamento da equipe'
              : visit.subject
              ? visit.subject.replace('\n', ' / ')
              : 'Treinamento da equipe'}
          </VisitDetailsSummaryValue>
        </VisitDetailsSummaryContent>
      </VisitDetailsSummaryItem>

      <VisitDetailsSummaryItem>
        <VisitDetailsSummaryIcon>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
              fill="#636363"
            />
          </svg>
        </VisitDetailsSummaryIcon>
        <VisitDetailsSummaryContent>
          <VisitDetailsSummaryLabel>Nome do consultor</VisitDetailsSummaryLabel>
          <VisitDetailsSummaryValue>
            {visit.consultant || localStorage.getItem('consultantName')}
          </VisitDetailsSummaryValue>
        </VisitDetailsSummaryContent>
      </VisitDetailsSummaryItem>
    </VisitDetailsSection>
  );

  return (
    <VisitDetailsModalOverlay onClick={onClose}>
      {renderModalContent()}
    </VisitDetailsModalOverlay>
  );
};

export default VisitDetailsModal;
